import {Storage} from '../platform-interfaces/storage';

const OPT_IN_STATUS_KEY = "analytics_opt_in";

export class OptInStateManager {
    private storage: Storage;

    constructor(storage: Storage) {
        this.storage = storage;
    }

    public async readOptInStatus(): Promise<boolean> {
        const val = await this.storage.getItem(OPT_IN_STATUS_KEY);
        return Promise.resolve(val !== null && JSON.parse(val))
    }

    public async updateOptInStatus(status: boolean): Promise<void> {
        await this.storage.setItem(OPT_IN_STATUS_KEY, `${status}`);
    }

}
